import {
  Alert,
  AlertTitle,
  Button,
  Checkbox,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";

interface Props {
  clientCode: string;
  clientName: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeprovisionDialog = ({ clientCode, clientName, onClose, onConfirm }: Props) => {
  const [confirmationText, setConfirmationText] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);

  const isValid = confirmationText === clientCode && isConfirmed;

  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Confirm Deprovisioning</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={3} sx={{ alignItems: "center" }}>
          <Alert severity="warning" sx={{ width: "100%" }}>
            <AlertTitle>
              You are about to delete <strong>{clientName}</strong> and all its data.
            </AlertTitle>
            <Typography>This action is permanent and cannot be undone.</Typography>
          </Alert>

          <Stack spacing={2} sx={{ width: "100%" }}>
            <TextField
              fullWidth
              label={`Type "${clientCode}" to confirm`}
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              placeholder={clientCode}
              autoComplete="off"
            />

            <FormControlLabel
              control={<Checkbox checked={isConfirmed} onChange={(e) => setIsConfirmed(e.target.checked)} />}
              label="I understand this will permanently delete the client and all its data"
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" color="error" disabled={!isValid} onClick={onConfirm}>
          Deprovision Client
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default ConfirmDeprovisionDialog;
